var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({},_vm.iconOn),[(!_vm.noTooltip)?_c('v-tooltip',{attrs:{"top":"","content-class":"ms-icon"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_vm._t("default",null,{"on":on})]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }